const WHATSAPP_NUMBER_PATTERN = /^[1-9]\d{7,14}$/;

export function buildWhatsAppSupportUrl({ whatsappNumber, company, email }) {
  const number = String(whatsappNumber || '').trim();
  if (!WHATSAPP_NUMBER_PATTERN.test(number)) return null;

  const companyName = String(company || '').trim();
  const accountEmail = String(email || '').trim();
  const message = [
    companyName ? `Hi, I need help with ${companyName}.` : 'Hi, I need help.',
    accountEmail ? `Account email: ${accountEmail}` : null,
  ].filter(Boolean).join('\n');

  return `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
}
